<template>
  <div>
    <v-expansion-panels
      multiple
      style="background-color: #c1d109"
      v-model="panel"
    >
      <v-expansion-panel
        v-for="(company, index) in events"
        :key="index"
        :class="company.ragBooked"
      >
        <v-expansion-panel-header>
          <span class="title white--text">
            {{ company.name | capitalize }} -
            {{ company.eventName | capitalize }}
            <span v-if="company.event[0].type !== 'register'">
              <span class="white--text"
                >({{ company.percentBooked }}% booked)</span
              >
              <span class="white--text"
                >&nbsp;({{ company.bookedCount }}/{{ company.slotCount }})</span
              >
              <span class="subtitle-1 grey--text"></span>
            </span>
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <ClientViewWorkshop
              :events="company.event"
              v-if="
                company.event[0].type === 'workshop' ||
                company.event[0].type === 'register'
              "
            ></ClientViewWorkshop>
            <ClientViewSlot
              :events="company.event"
              v-if="
                company.event[0].type === 'slot' ||
                company.event[0].type === 'healthscreening' ||
                company.event[0].type === 'virustesting'
              "
            ></ClientViewSlot>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import moment from "moment";
import { Booking } from "../classes/Booking";
import ClientViewWorkshop from "@/components/ClientViewWorkshop.vue";
import ClientViewSlot from "@/components/ClientViewSlot.vue";

export default {
  components: {
    ClientViewWorkshop,
    ClientViewSlot,
  },
  props: {
    eventData: Array,
  },
  data() {
    return {
      panel: [0],
      events: [],
    };
  },
  async created() {
    const that = this;
    const events = this.eventData;

    // Company
    events.map((event, eventIndex) => {
      if (event.eventCompany) {
        that.events[eventIndex] = {
          ...event.eventCompany,
          bookedCount: 0,
          slotCount: 0,
          percentBooked: 0,
          ragBooked: "red",
          eventName: event.name,
          event: [],
        };
        event.eventLocation.items.map((location, locationIndex) => {
          location.eventSlotGroup.items.map((slotGroup, slotGroupIndex) => {
            // Add event 2nd
            that.events[eventIndex].event.push({
              name: event.name,
              code: event.code,
              type: event.type,
              status: event.status,
              iCalendar: event.iCalendar,
              location: location.postcode,
              addressLine1: location.addressLine1,
              town: location.town,
              room: slotGroup.room,
              date: new Date(slotGroup.date),
              capacity: slotGroup.capacity,
              booked: 0,
              percentBooked: 0,
              bookedCount: 0,
              slotCount: 0,
              slot: [],
              slotId: slotGroup.id,
            });

            var customEventIndex = that.events[eventIndex].event.length - 1;

            // Slot group
            slotGroup.eventSlot.items.map((slot, slotIndex) => {
              // Add empty Slot
              let booking = {
                id: null,
                firstname: "",
                lastname: "",
                email: "",
                dob: "",
                mobile: "",
                time: slot.time,
                type: slot.type,
                booked: slot.booked,
                slotId: slot.id,
                iCalendar: event.iCalendar,
                cancelBooking:
                  slot.booked && slot.type === "SLOT" ? false : true,
              };

              // Set slot Id
              that.events[eventIndex].event[customEventIndex].slotId = slot.id;

              // Create empty slots
              if (
                event.type === "healthscreening" ||
                event.type === "slot" ||
                event.type === "virustesting"
              ) {
                that.events[eventIndex].event[customEventIndex].slot.push(
                  booking
                );
              }

              // Bookings
              slot.eventBooking.items.map((eventBooking, eventBookingIndex) => {
                // Overwrite default slot with booked slot
                let customData = {};
                if (eventBooking.customData) {
                  customData = JSON.parse(eventBooking.customData);
                }
                if (event.type === "workshop" || event.type === "register") {
                  that.events[eventIndex].event[customEventIndex].slot.push({
                    ...booking,
                    ...eventBooking,
                    ...customData,
                  });
                } else {
                  that.events[eventIndex].event[customEventIndex].slot[
                    slotIndex
                  ] = {
                    ...booking,
                    ...eventBooking,
                    ...customData,
                  };
                }

                if (slot.type !== "BREAK" && slot.type !== "BLOOD") {
                  // Accumulate total bookings per company
                  slot.type === "SLOT" && that.events[eventIndex].bookedCount++;
                  slot.type === "workshop" &&
                    that.events[eventIndex].bookedCount++;

                  // Acumulate total bookings per event
                  slot.type === "SLOT" &&
                    that.events[eventIndex].event[customEventIndex]
                      .bookedCount++;
                  slot.type === "workshop" &&
                    that.events[eventIndex].event[customEventIndex]
                      .bookedCount++;
                }
              });

              if (slot.type !== "BREAK" && slot.type !== "BLOOD") {
                // Accumulate total slots per company
                slot.type === "SLOT" && that.events[eventIndex].slotCount++;
                if (slot.type === "workshop") {
                  that.events[eventIndex].slotCount =
                    that.events[eventIndex].slotCount + slotGroup.capacity;
                }

                // Accumulate total slots per event
                slot.type === "SLOT" &&
                  that.events[eventIndex].event[customEventIndex].slotCount++;
                if (slot.type === "workshop") {
                  that.events[eventIndex].event[customEventIndex].slotCount =
                    that.events[eventIndex].event[customEventIndex].slotCount +
                    slotGroup.capacity;
                }
              }
            });
          });
          // Calculate Percent Booked
          if (that.events[eventIndex].bookedCount) {
            that.events[eventIndex].percentBooked = Math.round(
              (that.events[eventIndex].bookedCount /
                that.events[eventIndex].slotCount) *
                100
            );
          }

          if (that.events[eventIndex].percentBooked < 40) {
            that.events[eventIndex].ragBooked = "red";
          } else if (that.events[eventIndex].percentBooked <= 75) {
            that.events[eventIndex].ragBooked = "amber";
          } else if (that.events[eventIndex].percentBooked > 75) {
            that.events[eventIndex].ragBooked = "green";
          }
        });
      }
    });

    that.events = that.events.filter((company) => company.event.length > 0);
    that.events.map((company) => {
      company.event.sort(
        // Sort by date
        (a, b) => new Date(a.date) - new Date(b.date)
      );
    });
    return;
  }
};
</script>
<style scoped>
.red {
  background-color: #e53935 !important;
}
.amber {
  background-color: #ffb300 !important;
}
.green {
  background-color: #7cb342 !important;
}
</style>